import React, { useEffect } from 'react';
import addAudience from './../Helpers/audience';
import redirectIfRegistered from './../Helpers/redirectIfRegistered';

function LpContainer(props) {
    useEffect(() => {
        addAudience();
        if (!props.dontRedirect) {
            redirectIfRegistered();
        } else {
            console.log('dont redirect');
        }

    }, [])

    return (
        <div className="lp-container">
            {props.children}
        </div>
    );
}

export default LpContainer;